if (!customElements.get('enhanceify-cnc-location-widget')) {
  class EnhanceifyCncLocationWidget extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.variantPickupStock = this.querySelector('.variant-stock');
      this.changeLocationTrigger = this.querySelector('.cnc-current-location-widget');
      this.currentStoreLocation = this.querySelector('.cnc-current-location');
      this.currentStoreStatus = this.querySelector('.cnc-cl-message');
      this.currentStoreMessage = this.querySelector('.cnc-location-message');

      const closestForm = this.closest('.product__info-wrapper');
      const changeLocationContainer = this.querySelector('.cnc-choose-location');
      const setCurrentLocation = this.querySelector('.set-location');

      const variantId = closestForm?.querySelector('.product-variant-id')?.value;
      const customerId = this.querySelector('[name="customerId"]')?.value;
      const customersClosestLocationId = this.querySelector('[name="closestLocation"]')?.value;
      const onlineLocationId = this.querySelector('[name="onlineLocation"]')?.value;
      const countryCode = this.querySelector('[name="countryCode"]')?.value;
      const postcodeInput = this.querySelector('[name="customerPostCode"]');
      const deliveryChoice = localStorage.getItem('preferred_delivery_method');
      const pswShipping = this.querySelector('.psw-shipping');
      const pswCnc = this.querySelector('.psw-cnc');

      let locationData = localStorage.getItem('pickup_location')
        ? JSON.parse(localStorage.getItem('pickup_location'))
        : null;

      const postcode = postcodeInput?.value || locationData?.postcode;

      const locationId = customersClosestLocationId || locationData?.shopify_id;

      const inventoryPayload = {
        variant_id: variantId,
        location_id: locationId,
        online_location_id: onlineLocationId,
        postcode: postcode,
        country: countryCode,
        type: 'onload',
      };

      this.getVariantInventory(inventoryPayload, locationData);

      this.changeLocationTrigger?.addEventListener('click', () => {
        changeLocationContainer?.classList.toggle('active');
      });

      setCurrentLocation?.addEventListener('click', () => {
        const updatedPayload = {
          variant_id: variantId,
          online_location_id: onlineLocationId,
          postcode: postcodeInput?.value,
          country: countryCode,
          customer_id: customerId,
          type: 'update',
        };
        this.getVariantInventory(updatedPayload);
      });

      if (deliveryChoice) {
        if (deliveryChoice === 'pickup') {
          pswShipping.classList.remove('active');
          pswCnc.classList.add('active');
        } else {
          pswShipping.classList.add('active');
          pswCnc.classList.remove('active');
        }
      }

      pswShipping.addEventListener('click', function () {
        if (!pswShipping.classList.contains('oos')) {
          pswShipping.classList.toggle('active');
          pswCnc.classList.toggle('active');
          localStorage.setItem('preferred_delivery_method', 'ship');
        }
      });

      pswCnc.addEventListener('click', function () {
        if (!pswCnc.classList.contains('oos')) {
          pswShipping.classList.toggle('active');
          pswCnc.classList.toggle('active');
          localStorage.setItem('preferred_delivery_method', 'pickup');
        }
      });
    }

    getVariantInventory(inventoryPayload, locationData) {
      this.classList.add('loading');

      fetch(`${window.enhanceify.appUrl}/store_locations/getVariantInventory`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(inventoryPayload),
      })
        .then((res) => res.json())
        .then((data) => {
          const onlineStockMessage = this.querySelector('.psw-shipping p');
          const pswShipping = this.querySelector('.psw-shipping');
          const pswCnc = this.querySelector('.psw-cnc');
          const cncMessages = this.querySelector('.cnc-product-availability');

          if (data.status === 200) {
            const pickupTimeRaw = data.pickup?.time;
            const pickupTime = pickupTimeRaw === 'TWELVE_HOURS' ? 12 : 24;

            // Resolved store location — shown immediately regardless of
            // whether this particular variant has pickup stock there.
            // Previously this only got set inside the "has stock" branch
            // below, so the name/status silently stayed on the old value
            // until the next full page load re-read it from localStorage.
            const resolvedLocation = data.location || locationData;

            if (resolvedLocation) {
              this.currentStoreStatus.textContent = resolvedLocation.is_pickup
                ? 'Free Pickup at'
                : 'Your closest store';
              this.currentStoreLocation.textContent = resolvedLocation.name || '';
              this.currentStoreMessage.textContent = resolvedLocation.message || '';
            }

            if (data.nearest && resolvedLocation) {
              this.showNearestStoreMessage(resolvedLocation, inventoryPayload.postcode);
            } else {
              this.clearNearestStoreMessage();
            }

            if (inventoryPayload.type === 'update' && data.location) {
              localStorage.setItem('pickup_location', JSON.stringify(data.location));
            }

            // Online stock message
            if (data.online_stock === null || data.online_stock < 1) {
              onlineStockMessage.textContent = 'Out of stock';
            } else {
              const shipMsg = pswShipping?.querySelector('.psw-ship-msg')?.value;
              onlineStockMessage.textContent = shipMsg || 'In stock online';
            }

            // Pickup stock message
            if (!data.pickup || data.pickup.stock < 1) {
              this.variantPickupStock.textContent = 'Not available';
              pswCnc?.classList.add('oos');
            } else {
              this.variantPickupStock.innerHTML = `${data.pickup.stock} in stock <br/> Ready in ${pickupTime} hours`;
              pswCnc?.classList.remove('oos');
            }

            cncMessages.style.display = 'none';
            cncMessages.textContent = '';
          } else {
            cncMessages.textContent = 'No stores found. Please click below to see available stores.';
            cncMessages.style.display = 'block';
          }
        })
        .catch((err) => {
          console.error('Error fetching inventory:', err);
        })
        .finally(() => {
          this.classList.remove('loading');
        });
    }

    showNearestStoreMessage(locationData, enteredPostcode) {
      let messageEl = this.querySelector('.nearest-store-message');

      if (!messageEl) {
        messageEl = document.createElement('p');
        messageEl.classList.add('nearest-store-message');
        this.currentStoreMessage?.insertAdjacentElement('afterend', messageEl);
      }

      const postcodeText = enteredPostcode ? ` at ${enteredPostcode}` : '';
      messageEl.textContent = `Your closest Lincraft store is ${locationData?.name} (${locationData?.postcode}).`;
    }

    clearNearestStoreMessage() {
      this.querySelector('.nearest-store-message')?.remove();
    }
  }

  customElements.define('enhanceify-cnc-location-widget', EnhanceifyCncLocationWidget);
}
